import httpAdminClient from '@/plugins/httpAdminClient';

export default {
  getLogsList(activityId, page, perpage) {
    return httpAdminClient.get(`admin/train/activities/${activityId}/logs?page=${page}&per_page=${perpage}`);
  },
  export(id) {
    return httpAdminClient.get(`admin/train/activities/${id}/export_logs`);
  },
};



// WEBPACK FOOTER //
// ./src/apiSet/adminApis/train/logApi.js